// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import config from '../assets/config/auth_config.json';

const {
  domain,
  clientId,
  authorizationParams: { audience },
  apiUri,
  errorPath,
  adminRedirectUrl,
  clientRedirectUrl,
  coordinatorRedirectUrl,
  evaluatorRedirectUrl,
  superAdminRedirectUrl,
  consultantRedirectUrl,
  redirectUri,
  svagriha_url,
  griha_url,
  apiDomain,
  dashboardApiBaseUrl,
  appName,
  school_griha_url,
  verion,
  griha_old_base_url,
  jan_griha_url,
  water_griha_url,
  interior_griha_url,
  interior_griha_detailed_url,
  waste_griha_url,
} = config as {
  adminRedirectUrl: string;
  clientRedirectUrl: string;
  coordinatorRedirectUrl: string;
  domain: string;
  clientId: string;
  authorizationParams: {
    audience?: string;
  };
  redirectUri: string;
  svagriha_url: string;
  griha_url: string;
  apiUri: string;
  errorPath: string;
  apiDomain: string;
  dashboardApiBaseUrl: string;
  appName: string;
  verion: string;
  evaluatorRedirectUrl: string;
  superAdminRedirectUrl: string;
  consultantRedirectUrl: string;
  griha_old_base_url: string;
  school_griha_url: string;
  jan_griha_url: string;
  water_griha_url: string;
  interior_griha_url: string;
  waste_griha_url: string;
  interior_griha_detailed_url: string;
};

export const environment = {
  production: false,
  auth: {
    domain,
    clientId,
    cacheLocation: 'localstorage' as const,
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
    authorizationParams: {
      ...(audience ? { audience } : {}),
      redirect_uri: window.location.origin,
      scope: 'openid profile email offline_access',
    },
    errorPath,
  },
  httpInterceptor: {
    allowedList: [`${griha_url}/${apiUri}/*`],
  },
  redirect: {
    adminRedirectUrl: svagriha_url + '/' + adminRedirectUrl,
    clientRedirectUrl: svagriha_url + '/' + clientRedirectUrl,
    coordinatorRedirectUrl: svagriha_url + '/' + coordinatorRedirectUrl,
    evaluatorRedirectUrl: svagriha_url + '/' + evaluatorRedirectUrl,
    superAdminRedirectUrl: svagriha_url + '/' + superAdminRedirectUrl,
    consultantRedirectUrl: svagriha_url + '/' + consultantRedirectUrl,
    old_panel_base_url: griha_old_base_url,
    school_griha_url: school_griha_url,
    jan_griha_url: jan_griha_url,
    water_griha_url: water_griha_url,
    interior_griha_url: interior_griha_url,
    waste_griha_url: waste_griha_url,
    interior_griha_detailed_url: interior_griha_detailed_url,
  },
  apiDomain: apiDomain,
  dashboardApiBaseUrl: dashboardApiBaseUrl,
  appName: appName,
  verion: verion,
  logoutUrl: window.location.origin,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
